import { z } from "zod"
import { requiredMessage } from "@/models/common"
import { PHONE_COUNTRY_CODE_PREFIX_MIN_LENGTH } from "@/modules/patients/constants/Patient"

const isPhoneNumberInvalid = (phone?: string | null) => !phone || phone.length <= PHONE_COUNTRY_CODE_PREFIX_MIN_LENGTH

export const validatePhoneNumber = (
  ctx: z.RefinementCtx,
  phoneNumber?: string | null,
  pathField?: (string | number)[],
) => {
  if (isPhoneNumberInvalid(phoneNumber)) {
    ctx.addIssue({ code: "custom", path: pathField, message: requiredMessage })
  }
}
